/* global  localStorage */
export default function PasswordFormController(
  $location,
  $rootScope,
  $timeout,
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService
) {
  const vm = this;

  // Set Default Values
  vm.appIsLoaded = false;
  vm.loginIsProcessing = false;
  vm.password = '';
  vm.saveType = '';
  vm.userName = userService.userName;

  // Attach Event Handlers
  vm.handleLoginFormSubmit = _handleLoginFormSubmit;
  vm.backToLogin = _backToLogin;
  vm.passwordReset = _passwordReset;
  _activate();

  /** ***********************************************
   * Event Handlers
   */

  function _handleLoginFormSubmit() {
    if (!vm.userName) {
      return;
    }
    vm.referenceCode = _getItem('reference.code');
    vm.loginIsProcessing = true;
    loaderService.showViewLoader = true;
    orgDataService.login(vm.userName, vm.password, vm.referenceCode).then((loginResponse) => {
      /* OAuth server responded */
      if (loginResponse.status === 200 && loginResponse.data) {
        _loginSuccess(loginResponse);
      } else {
        _loginFailed('There was an error while logging in.');
      }
    }).catch(() => {
      _loginFailed('There was an error while logging in.');
    });
  }

  function _backToLogin() {
    $location.path('/login');
  }

  function _passwordReset() {
    $location.path('/passwordReset');
  }

  /** ***********************************************
   * Private Functions
   */

  function _activate() {
    // authorizationService.revokeToken();
    loaderService.showViewLoader = false;
    vm.appIsLoaded = true;
  }

  /**
   * OAuth server responded with something other than success
   * @param loginResponse
   */
  function _loginFailed(errorMessage) {
    vm.loginIsProcessing = false;
    authorizationService.revokeToken();
    userService.isLoggedOn = false;
    loaderService.showViewLoader = false;
    alerts.error(errorMessage);
  }

  function _loginSuccess(loginResponse) {
    const token = userService._getToken(loginResponse, vm.userName);
    authorizationService.setToken(token);

    return userService.refreshUser().then((user) => {
      console.log('User logged in', user);
      userService.isLoggedOn = true;

      const lastLocation = _getItem('lastAccessLocation');
      if (lastLocation) {
        navigateLastLocation(lastLocation);
      } else {
        $location.path('/home');
      }

      $rootScope.$broadcast('loggedIn');
      $timeout(() => {
        angular.element('html')[0].scrollTop = 0;
      }, 0);

      orgDataService.logUserAccess();
    }).catch((err) => {
      console.error(err);
      userService.isLoggedOn = false;
      if (err.data) {
        alerts.error(err.data.Message);
      }
    }).finally(() => {
      vm.loginIsProcessing = false;
      loaderService.showViewLoader = false;
    });
  }

  function _getItem(key) {
    return localStorage.getItem(key);
  }

  function _saveItem(key, obj) {
    localStorage.setItem(key, obj);
    return true;
  }

  function navigateLastLocation(lastLocation) {
    _saveItem('lastAccessLocation', '');
    if (lastLocation === '/support/tickets') {
      if ($rootScope.isAzureLog === true) {
        $location.path('/home');
      } else {
        $location.path(lastLocation);
      }
    } else {
      $location.path(lastLocation);
    }
  }
}

PasswordFormController.$inject = [
  '$location',
  '$rootScope',
  '$timeout',
  'alerts',
  'authorizationService',
  'userService',
  'loaderService',
  'orgDataService',
];
